import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess } from 'slices/auth/login/reducer';
import { loadUserPermissions } from 'slices/auth/login/thunk';
import TokenManager from './utils/tokenManager';
import configService from './services/configService';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//import Scss
import "assets/scss/themes.scss";

//imoprt Route
import Route from 'Routes/Index';

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
// fakeBackend();

const App = () => {
  const dispatch = useDispatch();

  // Initialize config service early (non-blocking)
  useEffect(() => {
    configService.initialize().catch((error) => {
      console.warn('Failed to initialize config service:', error);
      // App continues to work with fallback URLs
    });
  }, []);

  useEffect(() => {
    // Check if user is already authenticated
    const token = TokenManager.getToken();
    const userData = TokenManager.getUserData();
    
    console.log('App.tsx hydration debug:', { 
      hasToken: !!token, 
      hasUserData: !!userData,
      tokenLength: token?.length,
      userDataKeys: userData ? Object.keys(userData) : [],
      userDataSubRole: userData?.subRole,
      userDataRole: userData?.role,
      isAdmin: userData?.subRole === null || userData?.subRole === undefined
    });
    
    if (token && userData) {
      try {
        // Ensure the userData has the correct structure for Redux
        const hydratedUserData = {
          ...userData,
          role: userData.role || userData.subRole || null,
          subRole: userData.subRole || null
        };
        
        // Ensure admin users (subRole: null) are properly handled
        if (hydratedUserData.subRole === null || hydratedUserData.subRole === undefined) {
          hydratedUserData.role = null;
          hydratedUserData.subRole = null;
          console.log('Admin user detected - setting role and subRole to null');
        }
        
        console.log('Hydrating Redux state with:', {
          ...hydratedUserData,
          role: hydratedUserData.role,
          subRole: hydratedUserData.subRole,
          isAdmin: hydratedUserData.subRole === null
        });
        
        dispatch(loginSuccess(hydratedUserData));
        dispatch<any>(loadUserPermissions());
        console.log('Redux state hydrated successfully');
      } catch (error) {
        console.error('Failed to hydrate Redux state:', error);
        // Clear invalid data
        TokenManager.logout();
      }
    } else if (token && !userData) {
      // Token exists but no user data - try to get from legacy storage
      try {
        const legacyAuthUser = localStorage.getItem('authUser');
        if (legacyAuthUser) {
          const legacyUserData = JSON.parse(legacyAuthUser);
          if (legacyUserData.email || legacyUserData.id) {
            // Migrate legacy data
            const hydratedUserData = {
              ...legacyUserData,
              role: legacyUserData.role || legacyUserData.subRole || null,
              subRole: legacyUserData.subRole || null
            };
            
            // Ensure admin users (subRole: null) are properly handled
            if (hydratedUserData.subRole === null || hydratedUserData.subRole === undefined) {
              hydratedUserData.role = null;
              hydratedUserData.subRole = null;
              console.log('Admin user detected in legacy data - setting role and subRole to null');
            }
            
            console.log('Migrating legacy data:', {
              ...hydratedUserData,
              role: hydratedUserData.role,
              subRole: hydratedUserData.subRole,
              isAdmin: hydratedUserData.subRole === null
            });
            
            TokenManager.setUserData(hydratedUserData);
            dispatch(loginSuccess(hydratedUserData));
            dispatch<any>(loadUserPermissions());
            console.log('Legacy data migrated successfully');
            return;
          }
        }
        // If no valid legacy data, clear token
        console.log('Token exists but no valid user data found, clearing token');
        TokenManager.clearToken();
      } catch (error) {
        console.error('Error checking legacy storage:', error);
        TokenManager.clearToken();
      }
    } else if (!token && userData) {
      // User data exists but no token - clear user data
      console.log('User data exists but no token found, clearing user data');
      TokenManager.logout();
    } else {
      console.log('No token or user data found, user needs to login');
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <Route />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </React.Fragment>
  );
}

export default App;